import { cn } from '@osmosis/tailwind-ui/helpers/classes';
import * as React from 'react';
/**
 * Spotify icon.
 */
const Spotify = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    {...props}
    className={cn('w-full', props.className)}
  >
    <path
      fill="#1ED760"
      fillRule="evenodd"
      d="M28.648 15.957c-5.803-3.445-15.373-3.762-20.912-2.081a1.683 1.683 0 1 1-.978-3.222c6.359-1.93 16.929-1.557 23.608 2.408a1.684 1.684 0 0 1-1.718 2.895zm-.19 5.104a1.404 1.404 0 0 1-1.93.462c-4.838-2.973-12.214-3.835-17.937-2.097a1.405 1.405 0 0 1-1.752-.935 1.405 1.405 0 0 1 .936-1.75c6.538-1.984 14.665-1.024 20.22 2.39.66.407.868 1.271.463 1.93zm-2.203 4.901a1.121 1.121 0 0 1-1.543.374C20.486 23.752 15.165 23.169 8.9 24.6a1.121 1.121 0 1 1-.5-2.187c6.857-1.567 12.738-.893 17.483 2.006.529.324.695 1.015.372 1.543zM18 0C8.06 0 0 8.059 0 18c0 9.942 8.06 18 18 18 9.941 0 18-8.058 18-18 0-9.941-8.059-18-18-18z"
    />
  </svg>
);

export default Spotify;
